import { CSSProperties, FC } from 'react';
import { Button, Modal } from 'antd';
import styled from 'styled-components';

import { Icon } from '@/shared/uikit/Icon';

type ScenarioConfirmationModalProps = {
  content: string;
  onClose: () => void;
  title: string;
  onSubmit: () => void;
  submitButtonText: string;
  cancelButtonText: string;
  submitButtonStyle?: CSSProperties;
};

export const ScenarioConfirmationModal: FC<ScenarioConfirmationModalProps> = ({
  cancelButtonText,
  content,
  onClose,
  onSubmit,
  submitButtonText,
  title,
  submitButtonStyle,
}) => {
  return (
    <Modal open footer={null} closeIcon={null} width={600}>
      <ScenariosModalContainer>
        <ScenariosModalHeader>
          <ScenariosModalHeaderTitle>{title}</ScenariosModalHeaderTitle>
          <Icon name="x" size="s16" style={{ cursor: 'pointer' }} onClick={onClose} />
        </ScenariosModalHeader>
        <ScenariosModalContent>{content}</ScenariosModalContent>
        <ScenariosModalFooter>
          <Button type="default" onClick={onClose}>
            {cancelButtonText}
          </Button>
          <Button type="primary" onClick={onSubmit} style={submitButtonStyle}>
            {submitButtonText}
          </Button>
        </ScenariosModalFooter>
      </ScenariosModalContainer>
    </Modal>
  );
};

const ScenariosModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const ScenariosModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 8px;
`;

const ScenariosModalHeaderTitle = styled.div`
  font-family: 'Manrope';
  font-size: 22px;
  font-weight: 600;
`;
const ScenariosModalContent = styled.div`
  padding: 24px 0px;
`;
const ScenariosModalFooter = styled.div`
  display: flex;
  gap: 16px;
  align-self: flex-end;
`;
